<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { Txt } from '$global/components/Txt';
	import { getTailwindColor } from '$global/storybook-util/icons/utils/getTailwindColor';
	interface Props {
		isActive: boolean;
		label: string;
		color: string;
		class?: string;
	}

	let { ...props }: Props = $props();
</script>

<Txt
	variant="label2"
	class={twMerge(
		classNames('px-2 text-[0.75rem] font-medium', {
			'text-white': props.isActive,
		}),
		props.class
	)}
	style="color: {props.isActive
		? 'white'
		: getTailwindColor(`${props.color}-600`)}"
>
	{props.label}
</Txt>
